import { Injectable, inject } from "@angular/core";
import {Restaurant} from "../Services/qdm.service";
import {CookieService} from "ngx-cookie-service";

export interface RestaurantHistoryAbstract {
  add(cookieService: CookieService, restaurant: Restaurant): void;

  getAll(cookieService: CookieService): Restaurant[];

  removeRestaurantById(cookieService: CookieService, id: number): Restaurant[];
}

@Injectable({providedIn: 'root'})
export class RestaurantHistoryManager {
  private cookie = inject(CookieService);



  addRestaurant(rhAbstract: RestaurantHistoryAbstract, restaurant: Restaurant): void {
    rhAbstract.add(this.cookie, restaurant);
  }

  getRestaurant(rhAbstract: RestaurantHistoryAbstract): Restaurant[] {
    return rhAbstract.getAll(this.cookie);
  }

  removeRestaurantById(rhAbstract: RestaurantHistoryAbstract, id: number): Restaurant[] {
    return rhAbstract.removeRestaurantById(this.cookie, id);
  }
}
